import { BaseConfig } from '../ServiceConfig';

export interface CartConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.CartServiceConfigData';
  url: string;
  tenant: string;
  mode: string;
}

export const CartConfigurationFields: (keyof CartConfiguration)[] = [
  'url',
  'tenant',
  'mode',
];

export const BlankCartConfiguration: CartConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.CartServiceConfigData',
} as CartConfiguration;
